import { AutoLocaleProvider, mapKeys, updateDocumentLang } from "@aet/i18n"

import { renderMain } from "#/main"

import App from "./App"
import * as en from "./locales/en/messages.po"
import * as fr from "./locales/fr/messages.po"

function Main() {
  return (
    <AutoLocaleProvider
      initialMessages={{
        en: en.messages,
        fr: fr.messages,
        ...mapKeys(import.meta.glob("./locales/**/messages.po"), key =>
          key.slice(10, -12)
        ),
      }}
      onChange={updateDocumentLang}
    >
      <App />
    </AutoLocaleProvider>
  )
}

renderMain(<Main />)
